<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <h3>{{ "i18n.base.changePassword.header" | translate }}</h3>
    <form [formGroup]="changePasswordForm"> <!-- (ngSubmit)="changePassword()"-->
      <div class="form-group">
        <label for="oldPassword">{{ "i18n.base.changePassword.oldPassword" | translate }}</label>
        <input id="oldPassword" type="password" class="form-control" formControlName="oldPassword" appRequired appPasswordVisibility>
        <!--  placeholder="{{ 'i18n.base.changePassword.requirement' | translate }}" -->
        <app-error-messages [control]="oldPasswordControl"></app-error-messages>
      </div>
      <div class="form-group">
        <label for="newPassword">{{ "i18n.base.changePassword.newPassword" | translate }}</label>
        <input id="newPassword" type="password" class="form-control" formControlName="newPassword" appRequired appPasswordVisibility>
        <app-error-messages [control]="newPasswordControl"></app-error-messages>
      </div>
      <div class="form-group">
        <label for="newPasswordConfirm">{{ "i18n.base.changePassword.newPasswordConfirm" | translate }}</label>
        <input id="newPasswordConfirm" type="password" class="form-control" formControlName="newPasswordConfirm" appRequired appPasswordVisibility>
        <app-error-messages [control]="newPasswordConfirmControl"></app-error-messages>
      </div>
      <button type="submit" class="btn btn-primary" (click)="changePassword()"  [disabled]="!changePasswordForm.valid">
        @if (loading) {
          <div class="spinner-border spinner-border-sm me-3" role="status"></div>
        }
        {{ "i18n.base.changePassword.changePassword" | translate }}
      </button>
    </form>
  </div>
</div>
